<template>
<div id="maincontainer" class="container-fluid" >
        <div class="row main-content">
            <div class="col-sm-12 col-md-6 animated fadeInUp">
                <div class="small-title">
                    <h4 v-html="state.bannerHome.title"></h4> <hr>
                </div>
                <div class="text-container">
                    <h1>{{ state.bannerHome.bannerTextTop }}</h1><h1 style="margin-bottom:40px;">{{ state.bannerHome.bannerTextBottom }}</h1>
                    <div style="transform:skew(10deg);">
                    <a  href="#aboutus">{{ state.bannerHome.btnText }}</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 animated fadeInUp"><img class="img-container" src="../../assets/imgs/home_foto1.png"></div>
        </div>
    <about-us style="background-color:white;"></about-us>
    <services style="background-color:white;"></services>    
    <map-page style="background-color:white;"></map-page>    
    <Clientes style="background-color:white;"></Clientes>
    <Contacto style="background-color:white;"></Contacto>
</div>
</template>

<script>
import AboutUs from './HistoryPage'
import Services from './ServicesPage'
import MapPage from './MapPage'
import Clientes from './ClientesPage'
import Contacto from './ContactoPage'

export default { 

  methods:{
  },
  components:{  
    AboutUs, 
    Services,
    MapPage,
    Clientes,
    Contacto
  },
  computed:{
       logoblanco(){
        return require('../../assets/logos/logo_santoyo_blanco.png')  
      },
       state(){
        return this.$store.state.activeList
    }
  },
  mounted(){

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#maincontainer{
     background-color:$azul;
}
.main-content{
    margin-top:100px;
    padding:150px;
}


img.img-container {
    width:70%;
}
h4{
    color:white;
     display:inline-block;
}

hr{
    display:inline-block;
    width:30%;
    vertical-align:middle;
    height: 2px;
    border: 0;
    border-top: 1px solid $rojo;
    margin: 1em 1em;
    padding: 0; 

}
h1{
    color:white;
    font-size:75pt;
}

.text-container a{
    position:relative;
    text-decoration:none;
    color:white;
    background-color:$rojo;
    padding:10px;
    width: 150px;
	height: 100px;
	-webkit-transform: skew(20deg);
	-moz-transform: skew(20deg);
	 -o-transform: skew(20deg);
    }


.text-container{
    text-align:left;
    margin-top:5%;
}

.small-title{
    text-align:left;
    vertical-align:middle;
    
}

@media screen and (max-width:1414px) {
h1{
    font-size:60pt;
}

.main-content{
    height:100%;
}
img.img-container {
    width:80%;
}
}

@media screen and (max-width:1154px) {
h1{
    font-size:50pt;
}

}

@media screen and (max-width:1000px) {
img.img-container {
    margin-top:40px;
}
.small-title{
    text-align:left;
    vertical-align:middle;
    font-size:16px;
}
h4{
    font-size:16px;
}

}

@media screen and (max-width:650px) {
h1{
    font-size:40pt;
}

.main-content{
    height:100%;
    padding:80px 20px;
}

img.img-container {
    margin-top:40px;
    width:100%;
}
}
</style>



// WEBPACK FOOTER //
// HomePage.vue?4ab2cd7e